var map = {
	"./emi.bio.png": 3262,
	"./jonas.bio.png": 6481,
	"./juanker.bio.png": 7380,
	"./laura.bio.png": 2374,
	"./rocio.bio.png": 9803,
	"./sergio.bio.png": 8269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4354;